import PropTypes from 'prop-types';
import includes from 'lodash/includes';
import { determineHighestNumberFactory } from 'components/Comparison/LineItems/helpers';
import { useTranslation } from 'react-i18next';
// eslint-disable-next-line import/no-cycle
import {
  LineItemContainer,
  LineItem,
  LineItemValue,
} from 'components/Comparison/LineItems';

function determineBestTransmissionType({ vehicle1, vehicle2 }) {
  if (!vehicle1.transmission_gears || !vehicle2.transmission_gears) {
    return null;
  }

  return determineHighestNumberFactory('transmission_gears')({
    vehicle1,
    vehicle2,
  });
}

function numWheelDrive(vehicle) {
  if (includes(['4X4', '4WD', 'AWD'], vehicle.drivetrain)) {
    return 4;
  }
  return 2;
}

function determineBestDriveType({ vehicle1, vehicle2 }) {
  if (!vehicle1.drivetrain || !vehicle2.drivetrain) {
    return null;
  }

  if (numWheelDrive(vehicle1) > numWheelDrive(vehicle2)) {
    return vehicle1;
  }
  if (numWheelDrive(vehicle2) > numWheelDrive(vehicle1)) {
    return vehicle2;
  }

  return null;
}

function formattedHorsePower(vehicle) {
  // eslint-disable-next-line camelcase
  const { horse_power, horse_power_at_rpm } = vehicle;

  // eslint-disable-next-line camelcase
  if (!horse_power || !horse_power_at_rpm) {
    return 'N/A';
  }

  // eslint-disable-next-line camelcase
  return `${horse_power}+ HP @ ${horse_power_at_rpm} RPM`;
}

function formattedTorque(vehicle) {
  // eslint-disable-next-line camelcase
  const { torque, torque_at_rpm } = vehicle;

  // eslint-disable-next-line camelcase
  if (!torque) {
    return 'N/A';
  }

  // eslint-disable-next-line camelcase
  return `${torque}+ lb-ft @ ${torque_at_rpm} RPM`;
}

function formattedCylinders(vehicle) {
  if (!vehicle.engine_cylinders) {
    return 'N/A';
  }

  return `${vehicle.engine_block_type}${vehicle.engine_cylinders}`;
}

export default function UnderTheHood({ comparison }) {
  const { t } = useTranslation();
  return (
    <LineItemContainer
      title={t('comparison.lineItems.underTheHood.header')}
      comparison={comparison}
    >
      <LineItem title={t('comparison.lineItems.underTheHood.powertrain')}>
        <LineItemValue
          comparison={comparison}
          getValue={(vehicle) => vehicle.transmission}
          getSubText={() => t('comparison.lineItems.underTheHood.transmission')}
          determineWinner={determineBestTransmissionType}
        />
        <LineItemValue
          comparison={comparison}
          getValue={(vehicle) => vehicle.drivetrain}
          getSubText={() => t('comparison.lineItems.underTheHood.drivetrain')}
          determineWinner={determineBestDriveType}
        />
      </LineItem>
      <LineItem title={t('comparison.lineItems.underTheHood.drivetrain')}>
        <LineItemValue
          comparison={comparison}
          getValue={formattedHorsePower}
          getSubText={() => t('comparison.lineItems.underTheHood.horsePower')}
          determineWinner={determineHighestNumberFactory('horse_power')}
        />
        <LineItemValue
          comparison={comparison}
          getValue={formattedTorque}
          getSubText={() => t('comparison.lineItems.underTheHood.torque')}
          determineWinner={determineHighestNumberFactory('torque')}
        />
        <LineItemValue
          comparison={comparison}
          getValue={formattedCylinders}
          getSubText={() =>
            t('comparison.lineItems.underTheHood.engineCylinders')
          }
          determineWinner={determineHighestNumberFactory('engine_cylinders')}
        />
      </LineItem>
    </LineItemContainer>
  );
}
UnderTheHood.propTypes = {
  comparison: PropTypes.object,
};
